import React from "react";
import { fromJS } from "immutable";
import { Box, Input } from "@showitinc/showit-wc";

import PropertyEditor from "../../../../components/PropertyEditor";
import HTMLUtils from "../../../../utils/HTMLUtils";
import { INPUT_TYPE_NUMBER } from "../../../../constants/ElementConstants";
import { IFRAME_SCALE } from "../../../../constants/MergeConstants";
import { elementSyncUtils } from "../../../../utils/SyncUtils";
import { gatherProps } from "../../../../utils/Merge/MergeUtils.mjs";
import { formatPropUpdate } from "../../../../utils/PropertyUtils";
import SplitMergeWrapper from "../../../base/SplitMergeWrapper";
import CustomizeEffects from "../../shared/CustomizeEffects";

const gatherableProps = [IFRAME_SCALE];
const defaults = fromJS({
  if: {
    s: 100,
  },
});

const EmbedProperties = ({
  onPropUpdate,
  isLocked,
  element,
  layout,
  mappedElement,
}) => {
  const _onPropChange = (propInfo) => {
    onPropUpdate && onPropUpdate(propInfo);
  };

  const _onURLChange = (propInfo) => {
    propInfo.value = HTMLUtils.formatURL(propInfo.value);
    _onPropChange(propInfo);
  };

  const url = element.getIn(["content", "url"], "");
  const code = element.getIn(["content", "code"], "");
  const showCode = url.length === 0;
  const showScale = code.length > 0;
  const showURL = code.length === 0 || !showCode;

  const elemProps = defaults.mergeDeep(
    gatherProps(element, layout, gatherableProps)
  );
  const { isSynced, toggleSyncedProp, getPropName } = elementSyncUtils(
    element,
    _onPropChange,
    layout
  );

  return (
    <>
      {showURL && (
        <Input
          value={url}
          label="iFrame URL"
          onSIChange={(e) =>
            _onURLChange(formatPropUpdate("content.url", e.target.value, url))
          }
          disabled={isLocked}
          placeholder="https://example.com"
        />
      )}
      {showCode && (
        <PropertyEditor
          propName="content.code"
          value={code}
          isLocked={isLocked}
          placeholder="Click To Add"
          label="Custom Code"
          isHTML
          onChange={_onPropChange}
        />
      )}
      {showScale && (
        <Box mt="4">
          <SplitMergeWrapper
            sync={isSynced(IFRAME_SCALE)}
            toggleSync={() => toggleSyncedProp(IFRAME_SCALE)}
            layout={layout}
          >
            <Input
              context
              type={INPUT_TYPE_NUMBER}
              disabled={isLocked}
              value={elemProps.getIn(IFRAME_SCALE.split("."))}
              label="Scale"
              units="%"
              onSIBeforeChange={(e) =>
                _onPropChange(
                  formatPropUpdate(
                    getPropName(IFRAME_SCALE),
                    e.target.value,
                    elemProps.getIn(IFRAME_SCALE.split("."))
                  )
                )
              }
              onSIInput={(e) =>
                _onPropChange(
                  formatPropUpdate(
                    getPropName(IFRAME_SCALE),
                    e.target.value,
                    elemProps.getIn(IFRAME_SCALE.split(".")),
                    null,
                    false
                  )
                )
              }
            />
          </SplitMergeWrapper>
        </Box>
      )}
      <CustomizeEffects
        mappedElement={mappedElement}
        layout={layout}
        onPropUpdate={onPropUpdate}
        preparedElement={element}
      />
    </>
  );
};

export default EmbedProperties;
